import type { DeepRequired, FieldErrorsImpl, FieldValues } from "react-hook-form";

import useCommonFormErrorHandler from "@repo/shopify/hooks/useFormErrorHandler";

import { useLayoutStore } from "@store/layout";

export default function useFormErrorHandler<T extends FieldValues>({
  values,
  errors,
  keyOrders,
}: {
  values: T;
  errors?: Partial<FieldErrorsImpl<DeepRequired<T>>>;
  keyOrders?: string[];
}) {
  const { openToast } = useLayoutStore();

  return useCommonFormErrorHandler({
    values,
    errors,
    keyOrders,
    onToast: (message) => {
      openToast({ message });
    },
  });
}
